import styled, { css, keyframes } from 'styled-components';
import { KOALA } from 'HubStyleTokens/colors';
const shimmerAnimation = keyframes(["0%{left:-50%;}100%{left:100%;}"]);
export const skeletonShimmer = css(["overflow:hidden;position:relative;&::before{z-index:1;content:'';display:block;position:absolute;width:50%;height:100%;top:0;left:-50%;animation:", " 1s cubic-bezier(0.42,0,0.58,1) infinite;background:linear-gradient( to right,transparent 0%,", " 50%,transparent 100% );}"], shimmerAnimation, props => props.shimmercolor || 'rgba(255, 255, 255, 0.65)');
export const SkeletonWrapper = styled.div.withConfig({
  displayName: "Skeleton__SkeletonWrapper",
  componentId: "sc-1jp1ljk-0"
})(["", ""], skeletonShimmer);
export const SkeletonBlock = styled.div.withConfig({
  displayName: "Skeleton__SkeletonBlock",
  componentId: "sc-1jp1ljk-1"
})(["background-color:", ";"], props => props.color || KOALA);